module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAsklEQVRoQ+2Z0Q2AIAwFy0KdQSfXGbqQ/hklmtAUMJDzVwV676xEkwx+pMHXLxTwlqCZbSKyZOd2VV1rJ94kAQpwxEQCPAMOXd4uRSEUQqEgARQKAqQLoRAKBQmgUBDgowuZ2REcr8vtqnqtmwK6IM8mIYE/qN/nnDeBWmT5rOIgyW6UrYRDFz6rlMKiC5WSEmnzg4MESMBBgPdAEBZbCRRCoSCBKRVqwORzyCZdiAIcBE4FUcwxf/Ey9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add.png
// module id = QBcd
// module chunks = 1